import { type FC } from "react";

import { SelectedAddressView, useFeatureFlags } from "@jti/commerce";
import { AlertBanner } from "@jti/core-components/components/AlertBanner";

import type { CustomShippingOptionWidgetVariantsCommonProps } from "../../CustomShippingOptionWidget.types";
import { prepareAddressViewFormat } from "../../utils/prepareAddressViewFormat";
import { CustomShippingOptionWidgetVariantEmbeddedIterationTwo } from "../CustomShippingOptionWidgetVariantEmbeddedIterationTwo";

export const CustomShippingOptionWidgetVariantEmbedded: FC<CustomShippingOptionWidgetVariantsCommonProps> = ({
  selectedAddress,
  children,
  widgetError,
}) => {
  const { ffCheckoutV2EnableIteration2 } = useFeatureFlags();

  if (ffCheckoutV2EnableIteration2) {
    return (
      <CustomShippingOptionWidgetVariantEmbeddedIterationTwo
        selectedAddress={selectedAddress}
        widgetError={widgetError}
      >
        {children}
      </CustomShippingOptionWidgetVariantEmbeddedIterationTwo>
    );
  }

  return (
    <>
      {widgetError?.code && <AlertBanner tone="error" data-testid="widget-error" description={widgetError.message} />}

      {children}

      {selectedAddress && (
        <SelectedAddressView title={selectedAddress.storeName} address={prepareAddressViewFormat(selectedAddress)} />
      )}
    </>
  );
};
